import * as React from 'react';
import moment from 'moment-timezone';
import { TIMEZONE } from '../../../utils/constants';

import './DateCard.css';

interface Props {
    date?: Date;
}

export class DateCard extends React.PureComponent<Props> {

    static defaultProps = {
        date: new Date()
    };

    render() {
        return (
            <div className="dateBox" data-testid="date-card">
                <h3 className="text__center">
                    {moment(this.props.date).tz(TIMEZONE).format('ddd')}<br />
                    <strong>{moment(this.props.date).tz(TIMEZONE).format('D')}</strong><br />
                    {moment(this.props.date).tz(TIMEZONE).format('MMM')}
                </h3>
            </div>
        );
    }
}